export class OpenHistoryStats {
  static readonly type = '[History] - Open history stats';

  constructor(public readonly recordId: string, public readonly type: string, public readonly parentId: string | null = null) { }
}

export class CloseHistoryStats {
  static readonly type = '[History] - Close history stats';
}

export class GetHistoryStats {
  static readonly type = '[History] - Get history stats';

  constructor(public readonly recordId: string, public readonly type: string, public readonly parentId: string | null = null) {}
}
